<template>
    <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
  
      <v-data-table
        :headers="headers"
        :items="assessment_scheme_super_master_list"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Assessment Scheme</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            >
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on"
                  >Add Assessment Scheme</v-btn
                >
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
  
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="editedItem.name"
                            persistent-hint
                            :hint="
                              editedIndex == -1
                                ? 'For example :: Scheme 1, Scheme 2'
                                : 'For example ::  Scheme 1, Scheme 2'
                            "
                            label="Enter Assessment Scheme"
                            :rules="[(v) => !!v || 'required']"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
  
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn
                      color="primary darken-1"
                      @click="save"
                      :disabled="!valid"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
                >edit</v-icon
              >
            </v-avatar>
          </div>
        </template>
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </template>
      
      <script>
  import axios from "axios";
  export default {
    data: () => ({
      valid: false,
      overlay: false,
      errorMsg: {
        id: false,
      },
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: "",
      dialog: false,
      headers: [
        {
          text: "Assessment Scheme",
          align: "left",
          sortable: false,
          value: "name",
        },
        { text: "Actions", value: "action", sortable: false },
      ],
      assessment_scheme_super_master_list: [],
      editedIndex: -1,
      editedItem: {
        id: "",
        name: "",
      },
      defaultItem: {
        id: "",
        name: "",
      },
    }),
  
    computed: {
      formTitle() {
        return this.editedIndex === -1
          ? "New Assessment Scheme"
          : "Edit Assessment Scheme";
      },
    },
  
    watch: {
      dialog(val) {
        val || this.close();
      },
      overlay(val) {
        val = () => {
          this.overlay = false;
        };
      },
    },
    mounted() {
      this.onLoad();
    },
  
    methods: {
      initializeErrorMsgFalse() {
        this.errorMsg.id = false;
      },
      onLoad() {
        this.overlay = true;
        axios
          .post("/Admin/adminAssessmentSchemeSuperMaster")
          .then((res) => {
            if (res.data.msg == "200") {
              if ((this.load = true)) {
                this.overlay = false;
                this.assessment_scheme_super_master_list =
                  res.data.assessment_scheme_super_master_list;
              }
            } else {
              // this.overlay= false;
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
          })
          .finally(() => {
            var overlay = false;
          });
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
  
      editItem(item) {
        this.editedIndex =
          this.assessment_scheme_super_master_list.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
  
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
  
      save() {
        if (this.editedIndex > -1) {
          if (this.isValidated()) {
            axios
              .post("/Admin/editAdminAssessmentSchemeSuperMaster", this.editedItem)
              .then((res) => {
                if (res.data.status.code == "SUCCESS") {
                  Object.assign(
                    this.assessment_scheme_super_master_list[this.editedIndex],
                    this.editedItem
                  );
                  this.showSnackbar(
                    "#4caf50",
                    "Assessment Scheme Updated Successfully..."
                  );
                } else if (res.data.status.code == "NA") {
                  this.showSnackbar(
                    "#b71c1c",
                    "Assessment Scheme Already Present!!!"
                  );
                }
              })
              .catch((error) => {
                window.console.log(error);
              });
  
            this.close();
          }
        } else {
          axios
            .post("/Admin/saveAdminAssessmentSchemeSuperMaster", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                this.assessment_scheme_super_master_list.push(this.editedItem);
                this.showSnackbar(
                  "#4caf50",
                  res.data.status.message
                );
                this.onLoad();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  res.data.status.message
                );
              }
            })
            .catch((error) => {
              this.showSnackbar("#b71c1c", "Something went wrong...");
              window.console.log(error);
            })
            .finally(() => {
              this.overlay = false;
            });
  
          this.close();
        }
      },
  
      isValidated() {
        if (this.editedItem.id) {
          return true;
        } else {
          if (!this.editedItem.id) {
            this.errorMsg.id = true;
          }
  
          return false;
        }
      },
    },
  };
  </script>
      <style scoped>
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
  .v-icon-size {
    font-size: 20px;
  }
  .edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
  }
  .edit-avatar:hover {
    background-color: #b0bec5;
  }
  .edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
  }
  .edit-v-icon:hover {
    color: white;
  }
  </style>